import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ savedDateInSeconds }:any) => {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    const calculateCountdown = () => {
      const currentDateInSeconds = Math.floor(new Date().getTime() / 1000.0);
      const timeDifferenceInSeconds = savedDateInSeconds - currentDateInSeconds;
      const timeRemainingInSeconds = 24 * 60 * 60 + timeDifferenceInSeconds;
      const is24HoursPassed = timeDifferenceInSeconds <= -24 * 60 * 60;

      if (is24HoursPassed) {
        setCountdown(0); 
      } else {
        setCountdown(Math.max(0, timeRemainingInSeconds));
      }
    };

    const intervalId = setInterval(() => {
      calculateCountdown();
    }, 1000);  

    return () => clearInterval(intervalId);
  }, [savedDateInSeconds]);

  const formatTime = (timeInSeconds: number) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className="btnRewards">
      {formatTime(countdown)}  <span className="icoLocked material-symbols-outlined">lock</span>
    </div>
  );
};

export default CountdownTimer;
